import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-manager-container',
  templateUrl: './manager-container.component.html',
  styleUrls: ['./manager-container.component.scss']
})
export class ManagerContainerComponent implements OnInit {
  public isLoading: boolean = false;
  managerList?;
  @ViewChild('addNewManagerModal', {static: false}) public addNewManagerModal: ModalDirective;
  @ViewChild('removeManagerModal', {static: false}) public removeManagerModal: ModalDirective;


  managerDetails:FormGroup
  constructor(private fb: FormBuilder) {
    this.managerList=[{id:'temp',name:"temp Manager"}]
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.managerDetails = this.fb.group({
      // countryCode: ['', Validators.required],
      countryCode: ['', [Validators.required, Validators.pattern(/^\+\d{1,4}$/)]],
      mobileNumber: ['',[Validators.required, Validators.pattern(/^\d+$/)]],      
    });
  }





  addManager=()=>{
    this.createForm();
    this.addNewManagerModal.show();

  }



  onSubmit(): void {

    if (this.managerDetails.valid) {

      console.log(this.managerDetails);
      this.managerList=[...this.managerList,{id:'temp',name:"temp name"}]
    this.addNewManagerModal.hide();

    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.managerDetails);
    }
  }

  
  markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

removeManager=()=>{
  this.removeManagerModal.hide();
}

}
